module.exports = __webpack_public_path__ + "static/bg-sidebar-constructions-911d3dc447ea78342e3ec230f420ad70.svg";